
import { Link, useLocation } from 'react-router-dom';
import { Home, CreditCard, Clock, User, BarChart3, MessageCircle, Bluetooth } from 'lucide-react';

export const Navbar = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path ? 'bg-primary text-white' : 'text-gray-700';
  };
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 flex justify-around items-center py-2 px-4">
      <Link to="/" className={`p-2 rounded-full ${isActive('/')}`}>
        <Home size={24} />
      </Link>
      <Link to="/payment" className={`p-2 rounded-full ${isActive('/payment')}`}>
        <CreditCard size={24} />
      </Link>
      <Link to="/bluetooth" className={`p-2 rounded-full ${isActive('/bluetooth')}`}>
        <Bluetooth size={24} />
      </Link>
      <Link to="/history" className={`p-2 rounded-full ${isActive('/history')}`}>
        <Clock size={24} />
      </Link>
      <Link to="/profile" className={`p-2 rounded-full ${isActive('/profile')}`}>
        <User size={24} />
      </Link>
      <Link to="/backoffice" className={`p-2 rounded-full ${isActive('/backoffice')}`}>
        <BarChart3 size={24} />
      </Link>
      <Link to="/contact" className={`p-2 rounded-full ${isActive('/contact')}`}>
        <MessageCircle size={24} />
      </Link>
    </nav>
  );
};
